import {Component, Input} from '@angular/core';
import {BaseModalService} from './base-modal.service';

@Component({
  selector: 'app-base-modal',
  templateUrl: './base-modal.component.html',
  styleUrls: ['./base-modal.component.scss']
})
export class BaseModalComponent {
  @Input() header = true;
  @Input() footer = true;

  constructor(public baseModalService: BaseModalService) { }
}
